// © Microsoft Corporation. All rights reserved.
import React, { useState, useEffect} from 'react';
import GroupCall from './containers/GroupCall';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { reducer } from './core/reducers';
import thunk from 'redux-thunk';
//import EndCall from './components/EndCall';
//import HomeScreen from './components/HomeScreen';
import ConfigurationScreen from './containers/Configuration';
import PublicConfigurationScreen from './containers/PublicConfiguration';
import { loadTheme, initializeIcons } from '@fluentui/react';
import { utils } from './Utils/Utils';
import { CallEndReason } from '@azure/communication-calling';
//import appconfig from "./appconfig.json";
import AfterWorkingHours from 'components/AfterWorkingHours';
import UnSupportedBrowserScreen from 'components/UnSupportedBrowseScreen';
import InputForm from 'components/InputForm';
import {persistStore,persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {PersistGate} from 'redux-persist/integration/react'
import NationalDay from 'components/NationalDay';
//import MobileApp from 'components/MobileApp';
import  setLanguage  from 'translation';
const sdkVersion = require('../package.json').dependencies['@azure/communication-calling'];
const lastUpdated = `Last Updated ${utils.getBuildTime()} with @azure/communication-calling:${sdkVersion}`;

loadTheme({});
initializeIcons();


const persistConfig = {
  key : 'persist-key',
  storage
  }
  
const persistedReducer = persistReducer(persistConfig,reducer)

//const store = createStore(reducer, applyMiddleware(thunk));
export const store = createStore(persistedReducer, applyMiddleware(thunk));
export const persistedStore = persistStore(store)
 

const App = () => {
  const [page, setPage] = useState('home');
  const [callEndReason, setCallEndReason] = useState<CallEndReason | undefined>();
  const [meetingLink, setMeetingLink] = useState('');
  const [screenWidth, setScreenWidth] = useState(0);
  const[workingHours , setWorkingHours] = useState(false);
  //const[mobileWorkingHours , setMobileWorkingHours] = useState(false);
 
  useEffect( () => {
    getLanguage();
    inWorkingHours();
    const urlParams = new URLSearchParams(window.location.search);
    const link = urlParams.get('meetingLink');
    if (link) setMeetingLink(link);

    const setWindowWidth = () => {
      const width = typeof window !== 'undefined' ? window.innerWidth : 0;
      setScreenWidth(width);
    };

   /*  const handleTabClose = (event:any) => {
      event.preventDefault();
      utils.registerEvent("user disconnected");
    }; */
    //window.addEventListener('beforeunload', handleTabClose);
    setWindowWidth();
    window.addEventListener('resize', setWindowWidth);
   
    
    return () => {
     // window.removeEventListener('beforeunload', handleTabClose);
      window.removeEventListener('resize', setWindowWidth);
    };
  }, []);

  const getLanguage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (lang) localStorage.setItem("lang", lang);
    const language = localStorage.getItem("lang") ;
    setLanguage(language);
  };

   const getGroupIdFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const link = urlParams.get('meetingLink');
    if (link) setMeetingLink(link);
    return link;
  };
 
 
  const isConfigPage = () =>{
    const urlParams = new URLSearchParams(window.location.search);
    const config = urlParams.get('config');
    if(config == "true"){
      return true;
    }else{
      return false;
    }
  }

  const getGroupId = () => {
    return meetingLink;
  };

  const inWorkingHours = () =>{
    setWorkingHours(true);
    // const queryParams = new URLSearchParams(window.location.search)
    // let isPublic = queryParams.get("isPublic");
    // let serviceType = "";
    // if(isPublic == "true" ){
    //   serviceType = "gosi-public";
    // }else{
    //   serviceType = "gosi-establishment";
    // }
    // let url = appconfig.azure_reports_url +"/api/customer-meeting/isWorkingHours/"+serviceType;
   
    // fetch(url).then(response =>{
    //   return response.json();
    // }) .then(json => {
    //   if(json.statues == true){
    //     setWorkingHours(json.statues);
    //      setMobileWorkingHours(json.statues);
    //    }else{
    //     setMobileWorkingHours(false);
    //     //check24Hour();
    //    }
    //    // setWorkingHours("true");
    // }).catch(error =>{
    //   //setWorkingHours("true");
    // })
    //setWorkingHours(true);
  } 
// const check24Hour=()=>{
//   let url = appconfig.azure_reports_url +"/api/customer-meeting/isWorkingHours/24hours";
   
//     fetch(url).then(response =>{
//       return response.json();
//     }) .then(json => {
//          setWorkingHours(json.statues);
//     }).catch(error =>{
//       //setWorkingHours("true");
//     })
// }
   const isNationalDay = () =>{
    let date = new Date();
    if(date.getFullYear() == 2023 && date.getMonth() == 1 && date.getDate() == 22){
      return true;
    }else{
      return false;
    }
   }
  const getContent =  () => { 
     
   let isSupportedBrowser =  (window as any)["isSupportedBrowser"](); 
   const queryParams = new URLSearchParams(window.location.search);
   //let mobileApp = queryParams.get("mobileApp");
   let isPublic = queryParams.get("isPublic");
   const config = queryParams.get("config");
    if (page === 'home') {
      if(isNationalDay() == true){
        return <NationalDay />
      }
     
      if(workingHours == true ){ 
         if(isSupportedBrowser == false){
          return <UnSupportedBrowserScreen />
         } else {

         


          if(isPublic == "true"  && config != "true"){
            // if(mobileApp == "true"){
            //   //   if(mobileWorkingHours == true){
            //   // return <MobileApp/>
            //   //   }else{
            //   //     return <AfterWorkingHours/>
            //   //   }
            // }else{
            return <InputForm />
          ///}
        }
        if(isPublic == "true" && isConfigPage()){
          return (
            <PublicConfigurationScreen
              startCallHandler={() => setPage('call')}
              unsupportedStateHandler={() => setPage('unsupported')}
              callEndedHandler={(errorMsg: CallEndReason) => {
                setCallEndReason(errorMsg);
                setPage('error');
              }}
               groupId={getGroupId()}
              screenWidth={screenWidth}
            />
          );
        }else{
          
        return (
          <ConfigurationScreen
            startCallHandler={() => setPage('call')}
            unsupportedStateHandler={() => setPage('unsupported')}
            callEndedHandler={(errorMsg: CallEndReason) => {
              setCallEndReason(errorMsg);
              setPage('error');
            }}
             groupId={getGroupId()}
            screenWidth={screenWidth}
          />
        );   
        }
      }
      }else{
        return <AfterWorkingHours />
      }
      
  
    } else if (page === 'call') {
       
      if(getGroupId() != ""){
        return <GroupCall endCallHandler={() => setPage('endCall')} groupId={getGroupId()} screenWidth={screenWidth} />;
      }else {
        return  "";
      }
    } else if (page === 'endCall') {
      const queryParams = new URLSearchParams(window.location.search)
       const meetingID = queryParams.get("meetingID");
       let isPublic = queryParams.get("isPublic");
       let source = queryParams.get("source");
       const language = localStorage.getItem("lang") ;
       window.location.href = window.location.href.split('?')[0]+"rating?meetingID="+meetingID+ "&isPublic="+isPublic+"&source="+source+"&lang="+language;  
       return;
     // return <Rating />

      /*return (
        <EndCall
          message={'You left the call'}
          rejoinHandler={() => {
            window.location.href = window.location.href;
          }}
          homeHandler={() => {
            //window.location.href = window.location.href.split('?')[0];
            window.location.href = window.location.href.split('?')[0]+"rating";
          }}
        />
      ); */
    } else if (page === 'unsupported') {
      window.document.title = 'Unsupported browser';
      return (
        <>
          {/* <a href="https://docs.microsoft.com/en-us/azure/communication-services/concepts/voice-video-calling/calling-sdk-features#calling-client-library-browser-support">
            Learn more
          </a>
          &nbsp;about browsers and platforms supported by the web calling sdk */}
          
فضلا المتصفح غير مدعوم ، الرجاء استخدام متصفح اخر.
        </>
      );
    } else if (page === 'error') {
      window.document.title = 'Call Ended';
      return (
        <div>
          <div>{`The call has ended with this error code (Code: ${callEndReason?.code} Subcode: ${callEndReason?.subCode})`}</div>

          <div>
            <a href="https://docs.microsoft.com/en-us/azure/communication-services/concepts/troubleshooting-info?tabs=csharp%2Cjavascript%2Cdotnet">
              Learn more
            </a>
            &nbsp;about why this Azure Communication Services call has ended.
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  };

  if (page === 'home') {
    if( getGroupIdFromUrl()) {
      setPage('call');
    }
  }
  
 /* if (page === 'home' && isConfigPage()) {
    
    setPage('configuration');
  }*/
 //alert(page);
  //return <Provider store={store}>{getContent()}</Provider>;
  return <Provider store={store}><PersistGate persistor={persistedStore}>{getContent()}</PersistGate></Provider>;
};

window.setTimeout(() => {
  try {
    console.log(`Azure Communication Services sample group calling app: ${lastUpdated}`);
  } catch (e) {}
}, 0);

export default App;
